import { PostOrPage } from "@tryghost/content-api";
import { useEffect, useRef } from "react";

interface StaticGhostPageProps {
  page: PostOrPage;
  sidebar: PostOrPage;
  contentLinksOpenInNewTab?: boolean;
  sidebarLinksOpenInNewTab?: boolean;
}
export function StaticGhostPage({
  page,
  sidebar,
  contentLinksOpenInNewTab = false,
  sidebarLinksOpenInNewTab = true,
}: StaticGhostPageProps) {
  return (
    <div className="container container_content container-padding-responsive flex gap-4">
      <div className="bg-white lg:bg-bg-gray p-4 lg:rounded-lg small-text lg:ml-0 w-full">
        <GhostHtml
          html={page.html}
          openLinksInNewTab={contentLinksOpenInNewTab}
        />
      </div>
      <div className="max-lg:hidden lg:bg-bg-gray lg:p-4 lg:rounded-lg min-w-[350px]">
        <GhostHtml
          html={sidebar.html}
          openLinksInNewTab={sidebarLinksOpenInNewTab}
        />
      </div>
    </div>
  );
}

interface GhostHtmlProps {
  html?: string | null;
  openLinksInNewTab?: boolean;
}

export function GhostHtml({ html, openLinksInNewTab = false }: GhostHtmlProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!openLinksInNewTab) {
      return;
    }

    const links = containerRef.current?.querySelectorAll("a[href]");
    links?.forEach((link) => {
      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");
    });
  }, [html, openLinksInNewTab]);

  if (typeof html !== "string") {
    return null;
  }

  return <div ref={containerRef} dangerouslySetInnerHTML={{ __html: html }} />;
}
